import React from "react";
import type { ReactNode } from "react";
import { colors, spacing, typography } from "../../../design-system";

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

export default function DetailRow({ label, value }: DetailRowProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: spacing[3] + "px 0",
        borderBottom: "1px solid " + colors.borderSubtle,
      }}
    >
      <div style={{ ...typography.bodySm, color: colors.textSecondary }}>
        {label}
      </div>
      <div
        style={{
          ...typography.body,
          color: colors.textPrimary,
          fontFeatureSettings: '"tnum" 1',
        }}
      >
        {value}
      </div>
    </div>
  );
}